/* eslint-disable indent */
import React from 'react';
import { MdWork } from 'react-icons/md';
import useSpeech from '../../hooks/useSpeech';
import ME from '../../assets/headshot.png';
import harmony from '../../assets/harmony.png';
import molotov from '../../assets/molotov.png';
import './about.css';

/**
 * @typedef {Object} WorkExperience
 * @property {string} id - Uniquer identifier generated by crypto.randomUUID()
 * @property {string} company - Company name
 * @property {string} role - Job title
 * @property {string} duration - Employment period e.g. 'Aug 2022 – Present'
 * @property {string | null} emoji - Emoji icon or null if logo is used instead
 * @property { string | null} logo - Imported logo asset or null if emoji is used instead
 */
const workExperience = [
  {
    id: 'self-employed-2022',
    company: 'Self-Employed',
    role: 'Full Stack Developer',
    duration: 'Aug 2022 – Present',
    emoji: '💻',
    logo: null,
  },
  {
    id: 'molotov-2024',
    company: 'Molotovcocktail.tv',
    role: 'Full Stack Developer',
    duration: 'Nov 2024 – Apr 2025',
    emoji: null,
    logo: molotov,
  },
  {
    id: 'harmony-2010',
    company: 'Harmony Gold Mine',
    role: 'Cost Accountant',
    duration: 'June 2010 – Aug 2017',
    emoji: null,
    logo: harmony,
  },
];

const About = () => {
  const { toggle, stop, isPaused, isSpeaking } = useSpeech();
  const text =
    'Full Stack Web Developer with experience building responsive and scalable web applications using JavaScript, React, Node.js, and Ruby on Rails. Trained in modern development practices, including RESTful APIs, authentication systems, and collaborative Git workflows. Passionate about building clean user interfaces and reliable backend systems while continuously improving technical skills.';

  let buttonLabel = '🔊 Listen';
  if (isSpeaking && isPaused) buttonLabel = '▶️ Resume';
  else if (isSpeaking) buttonLabel = '⏸️ Pause';

  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="about me" />
          </div>
        </div>

        <div className="about__content">
          {/* Speech controls */}
          <div className="speech-controls">
            <button
              className="voice-btn"
              type="button"
              onClick={() => toggle(text)}
            >
              {buttonLabel}
            </button>
            <button
              className="stop-btn"
              type="button"
              onClick={stop}
              disabled={!isSpeaking}
            >
              ⛔ Stop
            </button>
          </div>

          <p>{text}</p>

          {/* Work Experience Card */}
          <div className="work__card">
            <div className="work__card-header">
              <MdWork className="work__card-icon" />
              <h5>Work Experience</h5>
            </div>

            <div className="work__list">
              {workExperience.map((job) => (
                <div className="work__item" key={job.id}>
                  <div className="work__item-logo">
                    {job.logo ? (
                      <img src={job.logo} alt={job.company} />
                    ) : (
                      <span>{job.emoji}</span>
                    )}
                  </div>
                  <div className="work__item-info">
                    <strong>{job.company}</strong>
                    <span className="work__item-role">{job.role}</span>
                  </div>
                  <span className="work__item-duration">{job.duration}</span>
                </div>
              ))}
            </div>
          </div>

          <a href="#contact" className="btn btn-primary">
            Let&apos;s Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
